import React from 'react';
import { isEnterForTheRow } from './accessibleElement';

interface Props extends React.HTMLAttributes<HTMLLIElement> {
  children: React.ReactNode;
  onActivate: Function;
}

export default React.forwardRef<HTMLLIElement, Props>(function AccessibleListElement(
  { children, onActivate, ...rest },
  ref,
) {
  return (
    <li
      ref={ref}
      tabIndex={0}
      onClick={() => onActivate()}
      onKeyDown={(ev) => isEnterForTheRow(ev) && onActivate()}
      {...rest}
    >
      {children}
    </li>
  );
});
